import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/Common/Card';
import Table from '../../components/Common/Table';
import api from '../../utils/api';
import { showDeleteConfirm, showSuccess, showError } from '../../utils/swal';

const DownPaymentList = () => {
  const [downPayments, setDownPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDownPayments();
  }, []);

  const fetchDownPayments = async () => {
    try {
      const response = await api.get('/down-payments');
      setDownPayments(response.data.data || response.data);
      setLoading(false);
    } catch (error) {
      console.error('Kaporalar yüklenemedi:', error);
      setLoading(false);
    }
  };

  const handleDelete = async (row) => {
    const customerName = `${row.customer?.name} ${row.customer?.surname}`;
    const result = await showDeleteConfirm(`${customerName} müşterisine ait kapora kaydı`);

    if (!result.isConfirmed) {
      return;
    }

    try {
      await api.delete(`/down-payments/${row.id}`);
      showSuccess('Kapora başarıyla silindi');
      fetchDownPayments();
    } catch (error) {
      console.error('Kapora silinemedi:', error);
      showError('Kapora silinirken bir hata oluştu');
    }
  };

  const columns = [
    {
      header: 'İşlemi Yapan Görevli',
      accessor: 'user',
      render: (row) => row.user?.name || '-'
    },
    {
      header: 'Müşteri',
      render: (row) => (
        <span
          className="text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer font-medium"
          onClick={(e) => {
            e.stopPropagation();
            if (row.customer?.id) navigate(`/customers/${row.customer.id}`);
          }}
        >
          {`${row.customer?.name || ''} ${row.customer?.surname || ''}`.trim() || '-'}
        </span>
      )
    },
    {
      header: 'Kapora Alınan Gayrimenkul',
      accessor: 'portfolio',
      render: (row) => (
        <span
          className="text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer font-medium"
          onClick={(e) => {
            e.stopPropagation();
            if (row.portfolio?.id) navigate(`/portfolios/${row.portfolio.id}`);
          }}
        >
          {row.portfolio?.title || '-'}
        </span>
      )
    },
    {
      header: 'Anlaşılan Fiyat',
      accessor: 'agreed_price',
      render: (row) => row.agreed_price ? `${row.agreed_price.toLocaleString('tr-TR')} ₺` : '-'
    },
    {
      header: 'Alınan Kapora',
      accessor: 'amount_received',
      render: (row) => row.amount_received ? `${row.amount_received.toLocaleString('tr-TR')} ₺` : '-'
    },
    {
      header: 'Kapora Tarihi',
      accessor: 'date',
      render: (row) => row.date ? new Date(row.date).toLocaleDateString('tr-TR') : '-'
    },
  ];

  if (loading) {
    return <div className="text-center py-8">Yükleniyor...</div>;
  }

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-800 dark:text-white mb-6">Kaporası Alınanlar</h1>

      <Card noPadding>
        <Table
          columns={columns}
          data={downPayments}
          onView={(row) => navigate(`/portfolios/${row.portfolio?.id}`)}
          onDelete={handleDelete}
        />
      </Card>
    </div>
  );
};

export default DownPaymentList;
